/** @format */

import { useEffect } from 'react'
import { asyncGetProductList, GlobalDataKey } from 'src/store/globalDataSlice'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, AppDispatch } from 'src/store'
import dayjs from 'dayjs'

/** 同一 dataType 并发只打一次，避免 CustomRoute + 页面 hook 首屏各 dispatch 一次 */
const inflightGlobalData = new Set<GlobalDataKey>()

const useGlobalData = (dataType: GlobalDataKey) => {
  const globalData = useSelector((state: RootState) => state.globalData)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    const data = globalData[dataType]
    const { list, startTime } = data
    const expired = startTime ? dayjs().diff(dayjs(startTime), 'days') > 0 : true
    if ((!list?.length || expired) && !inflightGlobalData.has(dataType)) {
      inflightGlobalData.add(dataType)
      const pending = dispatch(asyncGetProductList(dataType)) as unknown as Promise<unknown>
      Promise.resolve(pending).finally(() => {
        inflightGlobalData.delete(dataType)
      })
    }
  }, [])

  return globalData[dataType].list
}

export default useGlobalData
